module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_western_clothing@3x-46b889e5c75d63d2c3061088ab4cb603.webp";